import { Box } from "@mui/material";

import VehicleSelectorGroup from "@/src/components/atoms/VehicleSelectorGroup";

import HeroCtaButton from "@/src/pages/consumer/HomePage/components/HomePageHeader/HeroCtaButton";
import HeroInstructionsList from "@/src/pages/consumer/HomePage/components/HomePageHeader/HeroInstructionsList";
import HeroTitleCard from "@/src/pages/consumer/HomePage/components/HomePageHeader/HeroTitleCard";
import HeroVehicleImage from "@/src/pages/consumer/HomePage/components/HomePageHeader/HeroVehicleImage";
import {
  heroCanvasSx,
  heroContentSx,
  heroDividerSx,
  heroRootSx,
  heroSelectorRowSx,
  heroSelectorSectionSx,
  instructionsRowSx
} from "@/src/pages/consumer/HomePage/components/HomePageHeader/homePageHeader.styles";

import { VehicleType } from "@/src/types/types";

interface HomePageHeaderProps {
  onAuctionListingClick: () => void;
  buttonText: string;
  vehicleType: VehicleType;
}

const HomePageHeader = (props: HomePageHeaderProps) => {
  const { onAuctionListingClick, buttonText, vehicleType } = props;

  return (
    <Box sx={heroRootSx}>
      <Box sx={heroCanvasSx}>
        <Box sx={heroContentSx}>
          <HeroTitleCard />
          <HeroVehicleImage />
        </Box>
        <Box sx={heroSelectorSectionSx}>
          <Box sx={heroSelectorRowSx}>
            <VehicleSelectorGroup
              vehicleType={vehicleType}
              navigationView="homePageView"
            />
          </Box>
        </Box>
        <Box aria-hidden sx={heroDividerSx} />
      </Box>
      <Box sx={instructionsRowSx}>
        <HeroInstructionsList vehicleType={vehicleType} />
        <HeroCtaButton
          buttonText={buttonText}
          onClick={onAuctionListingClick}
        />
      </Box>
    </Box>
  );
};

export default HomePageHeader;
